/**
 * UN TEXTE N'EST JAMAIS DU HTML. Tout ce qui vient d'une fiche (un nom, une
 * note, un libelle saisi) passe par ici avant d'entrer dans un document : sans
 * ca, une fiche nommee `<img src=...>` ecrirait une balise dans le PDF, et le
 * serveur refuserait le document entier (`docs/PDF.md`, « Un HTML ferme »).
 *
 * `=`, `(` et `@` S'ECHAPPENT AUSSI, et ce n'est pas du zele : le filtre du
 * serveur lit le texte brut, sans chercher ou finit une balise. Une note qui
 * contient « src=... », « url(... » ou « @import » y serait lue comme une
 * ressource, et le PDF refuse. En entites, Chromium affiche les memes signes et
 * le filtre ne voit plus rien.
 */
export function echapper(texte: string): string {
  return texte
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/=/g, '&#61;')
    .replace(/\(/g, '&#40;')
    .replace(/@/g, '&#64;');
}
